<template>
  <div class="relative rounded-md">
    <div
      :class="[
        props.highlight
          ? 'bg-primary text-primary-fg'
          : 'text-background-fg',
        'absolute inset-y-0 right-0 flex w-10 items-center justify-center rounded-r-md border-l border-background-fg/8 text-background-fg',
      ]"
    >
      <span class="font-semibold"> % </span>
    </div>
    <input
      ref="inputRef"
      v-model="inputValue"
      :disabled="disabled"
      type="number"
      step="0.01"
      :name="name"
      :class="[
        'block w-full rounded-md border border-background-fg/8 pr-12 text-right text-base font-semibold focus:outline-none', // Font size set at >14px (text-base) so no zoom on mobile when focused
        hasError
          ? 'border-error text-error placeholder:text-error focus:border-error focus:ring-error'
          : 'focus:border-primary focus:ring-primary',
        disabled &&
          'w-full rounded-md border border-gray-300 p-2 text-gray-900 disabled:cursor-not-allowed disabled:border-gray-300 disabled:bg-gray-100 disabled:text-gray-500',
      ]"
      :placeholder="placeholder"
      :aria-invalid="hasError"
      enterKeyHint="done"
      @input="handleInput"
      @keydown.backspace="handleBackspace"
      @keydown.enter="handleEnter"
    />
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    highlight?: boolean
    modelValue: number | null
    name?: string
    hasError?: boolean
    disabled?: boolean
    placeholder?: string
  }>(),
  {
    highlight: false,
    name: undefined,
    hasError: false,
    disabled: false,
    supervisorRequired: false,
    placeholder: undefined,
  }
)

const emit =
  defineEmits<
    (
      eventName: "update:modelValue",
      value: number | null
    ) => void
  >()

const inputValue = ref(0)

watch(
  () => props.modelValue,
  (value) => {
    inputValue.value = value ?? 0
  },
  { immediate: true }
)
const handleInput = () => {
  inputValue.value = Math.min(Number(inputValue.value), 100)
  emit("update:modelValue", inputValue.value)
}

const handleBackspace = (event: KeyboardEvent) => {
  if (inputValue.value === 0) {
    event.preventDefault()
  }
}

const handleEnter = (event: Event) =>
  (event?.target as HTMLInputElement)?.blur()
</script>
